module.exports = __WEBPACK_EXTERNAL_MODULE_jPm4__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"@fiverr/gofor","commonjs2":"@fiverr/gofor","amd":"@fiverr/gofor","root":"goforFactory","var":"goforFactory"}
// module id = jPm4
// module chunks = 0 1